module.exports = "query Company  {\n  company {\n    logo\n    url\n    brands\n    permissions\n  }\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/queries/Company.graphql
// module id = 1869
// module chunks = 1610